import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/styles";
import { motion } from "framer-motion";

const DropDown = ({ categoriesData, setDropDown }) => {
  const navigate = useNavigate();
  const submitHandle = (i) => {
    navigate(`/products?category=${i.title}`);
    setDropDown(false);
    window.location.reload();
  };
  return (
    <motion.div
      initial={{ y: 30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="pb-4 w-[270px] bg-[#fff] absolute z-30 rounded-md shadow-sm"
    >
      {categoriesData &&
        categoriesData.map((i, index) => (
          <div
            key={index}
            className={`${styles.noramlFlex} border-b-[1px] border-orange-100 hover:bg-orange-100 cursor-pointer rounded-t-md`}
            onClick={() => submitHandle(i)}
          >
            <img
              src={i.image_Url}
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
                marginLeft: "10px",
                userSelect: "none",
              }}
              alt=""
            />
            <h5 className="m-3 cursor-pointer text-base capitalize select-none">
              {i.title}
            </h5>
          </div>
        ))}
    </motion.div>
  );
};

export default DropDown;
